import { render, staticRenderFns } from "./ItemsEditor.vue?vue&type=template&id=5aaf24fe&scoped=true"
import script from "./ItemsEditor.vue?vue&type=script&lang=js"
export * from "./ItemsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf24fe",
  null
  
)

export default component.exports